import { observer } from "mobx-react-lite";

import { useNewWebsiteTemplateFormState } from "./form.state";
import { NewWebsiteTemplateFormView } from "./form.view";

export const NewWebsiteTemplateForm = observer(() => {
  const state = useNewWebsiteTemplateFormState();
  return <NewWebsiteTemplateFormView state={state} />;
});
